import { useState, useCallback } from 'react';
import Link from 'next/link';

const MobileNav = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleIsOpen = useCallback(() => {
    setIsOpen(!isOpen);
  }, [setIsOpen, isOpen]);

  return (
    <>
      <button
        onClick={toggleIsOpen}
        className="navbar-toggler"
        type="button"
        aria-label="Toggle navigation"
      >
        <span className={`fal fa-${isOpen ? 'times' : 'bars'}`}></span>
      </button>
      <nav id="mobile-nav" className={isOpen ? 'open' : ''}>
        <div>
          {/* <form className="site-search" action="">
            <fieldset>
              <legend>Start Your Search</legend>
              
              <label className="sr-only" htmlFor="search">Search by job title or keyword</label>
              <input id="search" type="text" placeholder="Search by job title or keyword" />
              <label className="sr-only" htmlFor="location">Location</label>
              <input id="location" type="text" placeholder="Location" />
              <div className="submit fa-light fa-magnifying-glass">
                <input type="submit" value="Search" />
              </div>
            </fieldset>
          </form> */}
          <ul>
            <li>
              <Link href={`/employers`} passHref>
                For Employers
              </Link>
            </li>
            {/* <li>
              <Link href={`/events`} passHref>
                <a href={`/events`}>Events</a>
              </Link>
            </li> */}
            <li>
              <Link href={`/contact`} passHref>
                Contact
              </Link>
            </li>
            <li>
              <Link href={`/job-search`} passHref>
                Find Jobs
              </Link>
            </li>
            <li>
              <Link href={`/blog`} passHref>
                Articles
              </Link>
            </li>
            <li>
              <Link href={`/videos`} passHref>
                Videos
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
};

module.exports = MobileNav;
